import React from 'react'
import FooterLogo from '../components/FooterLogo'

const Contact = () => {
  return (
    <>
      <div className="page-container col-sm-9 clearfix">
        <div id="feedback-header">
          <div id="header-feedback-text">
            <span className="count-down">Contact Open Play Tennis</span>
            {/* <div className="px-3 pb-3 mt-4">
            <span className="contact-green-title">
              <p>City Tennis League, llc</p>
              <p>P.O. BOX 82457</p>
              <p>Portland, Oregon 97282-0457</p>
            </span>
          </div> */}
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-6 item-self-stretch">
            <div className="shadow-sm feedback-grey-box p-5 h-100 msg-body-container">
              <p>Questions related to a match or tournament</p>
              <p>Technical support or enhancements / suggestions</p>
              <p>Request a new city</p>
              <p className="mb-0">General information</p>
            </div>
          </div>
          <div className="col-lg-6 item-self-stretch">
            <div className="shadow-sm feedback-green-box p-5 h-100" style={{ color: 'black' }}>
              <p>Info@openplaytennis.com</p>
              <p>Info@openplaytennis.com</p>
              <p>Info@openplaytennis.com</p>
              <p className="mb-0">Tchair@openplaytennis.com</p>
            </div>
          </div>
        </div>
      </div>
      <div className='footer_space'></div>
      <FooterLogo />
    </>

  )
}

export default Contact